// Assistant tool schemas: one JSON-Schema tool per non-exempt route. The assistant context
// registers these with the model and dispatches a call to the route it names, under the same
// principal and the same `@platform/authz` check as the HTTP handler. Capability parity between
// the user and the assistant is therefore a build property, not a review item.
import { z } from 'zod';
import { actionSchema, authKindSchema, contextNameSchema, httpMethodSchema, } from '../manifest/types.js';
export const TOOL_NAME_PATTERN = /^[a-z][a-z0-9-]*_[A-Za-z][A-Za-z0-9_]*$/;
const jsonSchemaObject = z.record(z.string(), z.unknown());
export const assistantToolSchema = z.object({
    /** `<context>_<operationId>`. Unique across every context. */
    name: z.string().regex(TOOL_NAME_PATTERN),
    /** From the operation's TypeSpec doc comment. */
    description: z.string().min(1),
    context: contextNameSchema,
    operationId: z.string(),
    method: httpMethodSchema,
    path: z.string(),
    action: actionSchema,
    auth: authKindSchema,
    /**
     * JSON Schema (draft 2020-12 subset, fully dereferenced) for the tool input:
     * `{ params?, query?, body? }` mirroring the HTTP request.
     */
    inputSchema: jsonSchemaObject,
});
export const assistantToolsSchema = z.array(assistantToolSchema);
export function parseAssistantTools(value) {
    return assistantToolsSchema.parse(value);
}
//# sourceMappingURL=types.js.map